export const links = {
  discord: 'https://dsc.gg/kaizenmc',
  serverIp: 'play.kaizenmc.id',
  wiki: 'https://kaizenmc.fandom.com/'
} as const;